import FleetGallery from '../components/FleetGallery';

export default function Fleet() {
  return (
    <div className="container py-5">
      <h1 className="h2 fw-bold mb-3">Our Fleet</h1>
      <FleetGallery />
    </div>
  );
}
